import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCategories as getCategoriesAPI } from "./service";

export const getCategories = createAsyncThunk(
  "get/categories",
  async (payload) => {
    // const token = getFromLocalStorage("APP_TOKEN");
    const params = {
      // headers: {
      //   Authorization: `Bearer ${token}`,
      // },
    };
    const response = await getCategoriesAPI(payload, params);
    return response.data;
  }
);
